import { Pipe, PipeTransform } from '@angular/core';

export type StatLabelFormat = 'number' | 'pct' | 'thousands';

/**
 * Renders a stat value, falling back to `--` (or `--%`) while data is loading or
 * when the value is missing. Use across the account so empty/loading stats never
 * flash a misleading `0` while a request is in flight.
 *
 *   {{ count | statLabel: loading : 'thousands' }}   → "1,234" / "--"
 *   {{ pct   | statLabel: loading : 'pct' }}         → "37%" / "<1%" / "0%" / "--%"
 *   {{ value | statLabel: loading }}                 → "42" / "--"
 */
@Pipe({ name: 'statLabel' })
export class StatLabelPipe implements PipeTransform {
    transform(
        value: number | null | undefined,
        loading = false,
        format: StatLabelFormat = 'number',
    ): string {
        const placeholder = format === 'pct' ? '--%' : '--';
        if (loading || value == null || isNaN(value)) return placeholder;

        switch (format) {
            case 'pct':
                if (value <= 0) return '0%';
                if (value < 1) return '<1%';
                return Math.round(value) + '%';
            case 'thousands':
                return value.toLocaleString('en-US');
            default:
                return value.toString();
        }
    }
}
